export default [
  {
    delivery_time: "Forventet levering",
    download_receipt: "Download kvittering",
    need_help: "Har du brug for hjælp til din ordre?",
    need_help_description:
      "Vi har sendt dig et link, hvor du kan følge med hvor langt din ordre er. Du kan nemt åbne chatten og høre omkring din levering. Her er dit ordre nummer: ",
    order_canceled: "Ordren annulleret",
    order_no_paid: "Ordre er ikke betalt",
    pickup_time: "Forventet klar",
    step1: "Ordren er modtaget.",
    step1_description: "Din ordre er ved at blive gjort klar.",
    step2: "Klar. På vej!",
    step2_description: "Din ordre er gjort klar og på vej til dig nu.",
    step3: "Din ordre er leveret.",
    step2Pickup: "Klar!",
    step2_descriptionPickup: "Din bestilling er klar og kan afhentes nu.",
    need_help_descriptionPickup:
      "Følg din ordre status her. Hvis du har nogle spørgsmål så kan du kontakte os direkte. Dit ordre nummer er: ",
    step3Pickup: "Din ordre er gennemført.",
  },
];
